export default "__VITE_ASSET__NA4Zj6ev__"